<div
  cdkTrapFocus
  role="dialog"
  [attr.aria-modal]="true"
  [attr.aria-labelledby]="_dialogLabelId ?? undefined"
  class="flex flex-col"
  [ngClass]="{
    'min-h-[312px] min-w-[750px] max-w-[788px] landscape:w-[64vh] landscape:h-[80vh] portrait:w-[80vw]': datepicker.touchUi,
    'portrait:h-[100vw]': datepicker.touchUi && !_actionsPortal,
    'portrait:h-[115vw]': datepicker.touchUi && _actionsPortal
  }"
>
  <div class="grow flex flex-col justify-between p-6 sm:p-4">
    <mat-calendar
      class="block h-auto"
      [ngClass]="{
    'w-[268px]': !datepicker.touchUi,
    'w-full': datepicker.touchUi
  }"
      [id]="datepicker.id"
      [startAt]="datepicker.startAt"
      [startView]="datepicker.startView"
      [onlyView]="datepicker.onlyView"
      [selectEndOfPeriod]="datepicker.selectEndOfPeriod"
      [minDate]="datepicker._getMinDate()"
      [maxDate]="datepicker._getMaxDate()"
      [dateFilter]="datepicker._getDateFilter()"
      [headerComponent]="datepicker.calendarHeaderComponent"
      [selected]="_getSelected()"
      [dateClass]="datepicker.dateClass"
      [comparisonStart]="comparisonStart"
      [comparisonEnd]="comparisonEnd"
      [optional]="datepicker.optional"
      [dateRangePresets]="datepicker.dateRangePresets"
      [withTimeInput]="datepicker._getWithTime()"
      [@fadeInCalendar]="'enter'"
      (yearSelected)="datepicker._selectYear($event)"
      (monthSelected)="datepicker._selectMonth($event)"
      (viewChanged)="datepicker._viewChanged($event)"
      (_userSelection)="_handleUserSelection($event)"
    ></mat-calendar>

    <ng-template [cdkPortalOutlet]="_actionsPortal"></ng-template>

    <!-- Invisible close button for screen reader users. -->
    <button
      type="button"
      class="absolute top-full left-0 mt-2"
      [class.border-0]="!_closeButtonFocused"
      [class.h-[1px]]="!_closeButtonFocused"
      [class.-m-[1px]]="!_closeButtonFocused"
      [class.overflow-hidden]="!_closeButtonFocused"
      [class.p-0]="!_closeButtonFocused"
      [class.absolute]="!_closeButtonFocused"
      [class.w-[1px]]="!_closeButtonFocused"
      [class.whitespace-nowrap]="!_closeButtonFocused"
      [class.outline-0]="!_closeButtonFocused"
      [class.appearance-none]="!_closeButtonFocused"
      [class.left-0]="!_closeButtonFocused"
      (focus)="_closeButtonFocused = true"
      (blur)="_closeButtonFocused = false"
      (click)="datepicker.close()"
    >
      {{ _closeButtonText }}
    </button>
  </div>
</div>
